import { render, staticRenderFns } from "./LoadingExam.vue?vue&type=template&id=7b71ffba&scoped=true"
import script from "./LoadingExam.vue?vue&type=script&lang=js"
export * from "./LoadingExam.vue?vue&type=script&lang=js"
import style0 from "./LoadingExam.vue?vue&type=style&index=0&id=7b71ffba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b71ffba",
  null
  
)

export default component.exports